import { GenerateFileResult, ReportFileFormat, ReportGenerateParams } from 'app/common/types/reports/generateFile';
import type { Request } from '../../index'


type GenerateFileParams = {
  report_id: number;
  format: ReportFileFormat
}


export const convertParams = (params: ReportGenerateParams): [GenerateFileParams, null] => {
  const {
    reportID,
    format,
  } = params
  return [{
    report_id: parseInt(reportID, 10),
    format,
  }, null]
}

export const convertResult = (res: number): GenerateFileResult => {
  return res.toString()
}


export const GET_GENERATE_FILE: Request<
  GenerateFileParams,
  GenerateFileResult,
  void
> = ['reports/generate_file', 'get', ['data', 'report_file_id']]
